module.exports = __webpack_public_path__ + "img/icon_order.07aaa3c2.svg";